var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('projects-list',{attrs:{"projects":this.projects,"supervisors":this.supervisors,"contest-id":this.$route.params.id,"secretary":_vm.isSecretary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }